var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopping7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.498 46.183 1.004 1.73c.716-.416 1.419-.876 2.09-1.368l-1.183-1.613c-.614.451-1.257.872-1.911 1.251z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.806 30.864c-.651 4.753-2.955 9.187-6.487 12.483l1.364 1.463c3.868-3.61 6.391-8.467 7.104-13.675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 17.382h2v2.236h-2z",
    transform: "matrix(.447 -.894 .894 .447 -.516 36.165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.882 17.5h2.236v2h-2.236z",
    transform: "matrix(.894 -.447 .447 .894 -7.007 7.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.882 19.5h2.236v2h-2.236z",
    transform: "matrix(.894 -.447 .447 .894 -7.056 11.109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 13.382h2v2.236h-2z",
    transform: "matrix(.447 -.894 .894 .447 6.378 39.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.882 18.5h2.236v2h-2.236z",
    transform: "matrix(.894 -.447 .447 .894 -5.026 17.711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 19.382h2v2.236h-2z",
    transform: "matrix(.447 -.894 .894 .447 4.881 48.898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.586 17h2.828v2h-2.828z",
    transform: "matrix(.707 -.707 .707 .707 1.331 39.213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 20.382h2v2.236h-2z",
    transform: "matrix(.447 -.894 .894 .447 8.962 57.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 23c0-3.309-2.691-6-6-6-.028 0-.056 0-.083 0-.478-2.834-2.949-5-5.917-5-2.413 0-4.537 1.438-5.479 3.569-.788-.375-1.642-.569-2.521-.569 0-3.309-2.691-6-6-6-2.413 0-4.537 1.438-5.479 3.569-.788-.375-1.642-.569-2.521-.569-2.636 0-4.901 1.717-5.684 4.15-.988-.228-2.02-.196-3.003.104-.347-.679-.819-1.267-1.373-1.757 3.521-1.222 6.06-4.565 6.06-8.497v-5h-1c-4.461 0-8.164 3.266-8.869 7.531-1.647-2.142-4.227-3.531-7.131-3.531h-5v1c0 4.5 3.324 8.229 7.644 8.886-1.016 1.076-1.644 2.521-1.644 4.114 0 1.538.586 2.937 1.54 4h-1.54v5c0 5.217 1.667 10.317 4.691 14.542-6.633 1.951-10.691 5.504-10.691 9.458 0 6.168 9.664 11 22 11s22-4.832 22-11c0-.006-.001-.011-.001-.017 10.635-3.094 18.001-12.825 18.001-23.983v-5zm-52 4v-2h52v2zm6-17c0-3.521 2.612-6.442 6-6.929v2.929c0 3.521-2.612 6.442-6 6.929zm-11.929-3h2.929c3.521 0 6.442 2.612 6.929 6h-2.929c-3.521 0-6.442-2.612-6.929-6zm5.929 12c0-2.206 1.794-4 4-4 1.758 0 3.287 1.143 3.805 2.843l.346 1.137 1.061-.536c1.125-.569 2.325-.582 3.43-.081l1.255.568.151-1.37c.225-2.03 1.924-3.561 3.952-3.561.889 0 1.743.305 2.469.881l1.305 1.036.3-1.639c.348-1.9 1.999-3.278 3.926-3.278 2.206 0 4 1.794 4 4 0 .28-.039.579-.117.914l-.371 1.571 1.572-.368c.337-.078.637-.117.916-.117.889 0 1.743.305 2.469.881l1.305 1.036.3-1.639c.348-1.9 1.999-3.278 3.926-3.278 2.206 0 4 1.794 4.006 3.905l-.033 1.429 1.219-.252c.263-.055.535-.082.808-.082 2.206 0 4 1.794 4 4h-46c-2.206 0-4-1.794-4-4zm23.352 40.915c2.294-2.073 4.648-4.924 4.648-7.915h-2c0 2.903-3.483 6.35-6.815 8.669-1.638.206-3.347.326-5.107.329 2.51-2.025 5.922-5.43 5.922-8.998h-2c0 3.246-4.345 7.015-7.112 8.874-1.403-.104-2.762-.273-4.06-.506 2.414-2.081 5.172-5.16 5.172-8.368h-2c0 3.04-3.708 6.311-5.676 7.831-1.319-.338-2.541-.744-3.661-1.202 2.214-2.331 3.337-4.556 3.337-6.629h-2c0 1.653-1.137 3.628-3.27 5.734-2.935-1.57-4.73-3.577-4.73-5.734 0-3.214 4.158-6.315 10.593-7.902.546-.135 1.103-.2 1.657-.2 1.282 0 2.552.354 3.641 1.034 1.102.689 2.561 1.068 4.109 1.068s3.007-.379 4.108-1.068c1.56-.976 3.49-1.281 5.298-.834 6.436 1.587 10.594 4.688 10.594 7.902 0 3.37-4.372 6.377-10.648 7.915zm12.284-9.909c-1.212-3.395-5.478-6.304-11.751-7.85-2.329-.577-4.821-.181-6.837 1.08-1.552.971-4.544.971-6.096 0-1.821-1.139-4.029-1.561-6.156-1.212-2.883-3.74-4.545-8.306-4.753-13.024h51.915c-.422 9.774-6.963 18.193-16.322 21.006z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 51,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping7);
export default __webpack_public_path__ + "static/media/shopping-7.89bbd0e4.svg";
export { ForwardRef as ReactComponent };